module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av662-7f1c8a362222dd201d54c5c75d67fa74.jpg";